import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { AuthProvider } from './contexts/AuthContext'
import ErrorBoundary from './ErrorBoundary'
import App from './App.jsx'
import Login from './pages/Login.jsx'
import OperatorAdmin from './pages/OperatorAdmin.jsx'
import ProtectedRoute from './components/ProtectedRoute.jsx'
import OperatorEdit from './pages/OperatorManagement/OperatorEdit.jsx'
import './index.css'

console.log('🚀 Application starting...')
console.log('Root element:', document.getElementById('root'))

try {
  const rootElement = document.getElementById('root')
  
  if (!rootElement) {
    throw new Error('Root element not found! Check index.html for <div id="root"></div>')
  }

  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <ErrorBoundary>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Navigate to="/login" replace />} />
              <Route path="/login" element={<Login />} />
              
              {/* Operator Management Routes */}
              <Route
                path="/operator"
                element={
                  <ProtectedRoute>
                    <div className="h-screen overflow-y-auto bg-gray-50 font-sans">
                      <OperatorAdmin />
                    </div>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/operator/create"
                element={
                  <ProtectedRoute>
                    <div className="h-screen overflow-y-auto bg-gray-50 font-sans">
                      <OperatorAdmin />
                    </div>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/operator/edit/:encryptedId"
                element={
                  <ProtectedRoute>
                    <OperatorEdit />
                  </ProtectedRoute>
                }
              />
              
              {/* Main App Routes */}
              <Route
                path="/app"
                element={
                  <ProtectedRoute>
                    <App />
                  </ProtectedRoute>
                }
              />
              
              {/* Catch all - redirect to login */}
              <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
          </BrowserRouter>
          {/* Toast Notifications Container */}
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        </AuthProvider>
      </ErrorBoundary>
    </React.StrictMode>,
  )
  
  console.log('✅ Application rendered successfully!')
} catch (error) {
  console.error('❌ Failed to render application:', error)
  const wrap = document.createElement('div')
  wrap.style.padding = '20px'
  wrap.style.fontFamily = 'sans-serif'

  const title = document.createElement('h1')
  title.style.color = 'red'
  title.textContent = 'Application Failed to Load.'
  wrap.appendChild(title)

  const msg = document.createElement('p')
  const strong = document.createElement('strong')
  strong.textContent = 'Error: '
  msg.appendChild(strong)
  msg.appendChild(document.createTextNode(String(error?.message || error)))
  wrap.appendChild(msg)

  const pre = document.createElement('pre')
  pre.style.background = '#f5f5f5'
  pre.style.padding = '10px'
  pre.style.borderRadius = '4px'
  pre.style.overflow = 'auto'
  pre.textContent = String(error?.stack || '')
  wrap.appendChild(pre)

  const hint = document.createElement('p')
  hint.textContent = 'Check the browser console for more details.'
  wrap.appendChild(hint)

  document.body.replaceChildren(wrap)
}
